import React, { FunctionComponent, useMemo, useState } from "react";
import { GameInfoProps } from "../../type";
import Utils from "../../utils";
import { NotFoundView } from "../not-found";
import { Setting } from "./types";
import CoinDozerUtils from "./utils";
import "./coin-dozer.scss";

export const CoinDozerSettingView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const { currencies = [] } = data as Setting;
  const [showCurrency, setShowCurrency] = useState(
    Object.values(currencies)[0]?.currency ?? ""
  );
  const currencySetting = useMemo(
    () => currencies.find((s) => s.currency === showCurrency),
    [showCurrency, currencies]
  );
  if (!currencySetting) return <NotFoundView />;
  Utils.setCurrencySymbol(currencySetting.symbol);
  const orderedPayout = CoinDozerUtils.GetSymbols();
  return (
    <>
      <ul className="nav nav-pills mb-3">
        {Object.values(currencies).map((c) => (
          <li key={c.currency} className="nav-item">
            <button
              className={`nav-link${
                c.currency === showCurrency ? " active" : ""
              }`}
              onClick={() => {
                setShowCurrency(c.currency);
              }}
            >
              {c.currency}
            </button>
          </li>
        ))}
      </ul>
      <div className="table-responsive">
        <table className="table table-bordered table table-striped-columns">
          <colgroup>
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"18%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"50%"} />
          </colgroup>
          <thead>
            <tr>
              <th className="align-middle">Min Bet</th>
              <th className="align-middle">Max Bet</th>
              <th className="align-middle">Multiplier</th>
              <th className="align-middle">Min Payout</th>
              <th className="align-middle">Max Payout</th>
              <th className="align-middle">Chip Options</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="align-middle">
                {Utils.asCurrency(currencySetting.minBet)}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(currencySetting.maxBet)}
              </td>
              <td>
                {orderedPayout.map(([symbol, payout], i) => (
                  <div key={symbol} className="row">
                    <div className="col col-sm-12 col-md-4 d-flex justify-content-center">
                      {CoinDozerUtils.convertSymbol(+symbol)}
                    </div>
                    <div
                      className="col col-sm-12 col-md-8 text-center
                    "
                    >
                      {payout.join(" ~ ")}
                    </div>
                  </div>
                ))}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(
                  currencySetting.minBet * orderedPayout[0][1][0]
                )}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(
                  CoinDozerUtils.maxPayoutFormular(currencySetting.maxBet)
                )}
              </td>
              <td className="align-middle">
                {currencySetting.chipOptions
                  .map((c) => Utils.asCurrency(c))
                  .join(", ")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
